export default __webpack_public_path__ + "static/media/Textilslöjd5.a6e7392c.jpeg";